import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import ComparisonPage from "./pages/ComparisonPage";
import DemoPage from "./pages/DemoPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import FAQPage from "./pages/FAQPage";
import NotFoundPage from "./pages/NotFoundPage";
import TicketsPage from "./pages/TicketsPage";
import TicketDetailPage from "./pages/TicketDetailPage";
import DownloadsPage from "./pages/DownloadsPage";
import LicensesPage from "./pages/LicensesPage";
import DeploymentPage from "./pages/DeploymentPage";
import TrainingsPage from "./pages/TrainingsPage";
import SchedulePage from "./pages/SchedulePage";
import OnboardingPage from "./pages/OnboardingPage";
import CRMPage from "./pages/CRMPage";
import TutorialsPage from "./pages/TutorialsPage";
import TutorialDetailPage from "./pages/TutorialDetailPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import CaseStudyDetailPage from "./pages/CaseStudyDetailPage";
import ProfilePage from "./pages/ProfilePage";

function App() {
  return (
    <ThemeProvider>
      <Router>
      <Routes>
        {/* Públicas */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/comparativos" element={<ComparisonPage />} />
        <Route path="/solicitar-demo" element={<DemoPage />} />

        {/* Conteúdo */}
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/tutoriais" element={<TutorialsPage />} />
        <Route path="/tutoriais/:slug" element={<TutorialDetailPage />} />
        <Route path="/casos-de-sucesso" element={<CaseStudiesPage />} />
        <Route path="/casos-de-sucesso/:slug" element={<CaseStudyDetailPage />} />

        {/* Portal do Cliente */}
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/perfil" element={<ProfilePage />} />
        <Route path="/chamados" element={<TicketsPage />} />
        <Route path="/chamados/:id" element={<TicketDetailPage />} />
        <Route path="/downloads" element={<DownloadsPage />} />
        <Route path="/licencas" element={<LicensesPage />} />
        <Route path="/cliente/implantacao" element={<DeploymentPage />} />
        <Route path="/treinamentos" element={<TrainingsPage />} />
        <Route path="/cronograma" element={<SchedulePage />} />

        {/* Onboarding */}
        <Route path="/onboarding" element={<OnboardingPage />} />

        {/* CRM */}
        <Route path="/crm" element={<CRMPage />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
    </ThemeProvider>
  );
}

export default App;
